import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenIdService } from '../token-id.service';
// Assuming you have an authentication service that provides user role
// import { AuthService } from '../auth.service'; 

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private tokenIdService: TokenIdService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const expectedRole = route.data['roleType'];
    const token = this.tokenIdService.getAuthToken();

    // No token -> redirect to appropriate login/home
    if (!token) {
      return this.redirect(expectedRole, state.url);
    }

    // Expired token -> clear and redirect
    if (this.tokenIdService.isTokenExpired(token)) {
      this.tokenIdService.clearTokens();
      return this.redirect(expectedRole, state.url);
    }

    // Role check
    const role = this.tokenIdService.getRoleTypeFromToken(token);
    if (!role || role !== expectedRole) {
      return this.redirect(expectedRole, state.url);
    }

    return true;
  }

  private redirect(expectedRole: string, returnUrl: string): UrlTree {
    // If admin route expected, go to admin login; else to home with redirect param
    if (expectedRole === 'admin') {
      return this.router.createUrlTree(['/admin/login'], { queryParams: { redirect: returnUrl } });
    }
    return this.router.createUrlTree(['/'], { queryParams: { redirect: returnUrl } });
  }
}